export default __webpack_public_path__ + "static/images/fb.9ed52c56.png";